<div id="container-home-page">
  <div
    class="row justify-content-center align-items-center px-5 pt-5 pb-0 home-page-light-blue-bg-color">
    <div class="col-6 text-center text-black mt-4">
      <h2 class="fw-bold font-size-40">
        Boost Resident Well-Being Through Validated Measures
      </h2>
      <p class="my-4 font-size-16">
        Gain insights into residents' happiness and well-being through real-time
        Quality of Life assessments and scores.
      </p>
      <a
        class="btn btn-lg schedule-demo-button px-5 text-white mt-3 mb-4"
        href="https://get.tsolife.com/contact-us"
        target="_blank">
        Get Started
      </a>
    </div>
    <div class="col-7">
      <img
        class="card-img img-fluid"
        src="assets/images/quality-of-life-page/qol-hero.png"
        alt="Resident Insights Hero" />
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Measurably Enhancing Residents' Quality of Life</h2>
      <p class="mt-4 font-size-17">
        Utilizing three validated Quality of Life scales to assess residents'
        happiness and well-being in real-time, our platform allows users to
        quantifiably measure the long-term impact of programs on resident
        satisfaction.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Capture Resident Wellness Insights Through Interviews
          </h2>
          <p class="card-text img-info-body">
            During the resident interview process, we seamlessly integrate a
            Quality of Life assessment that aligns naturally with the
            conversation.
            <br />
            <br />
            This assessment includes questions derived from three validated
            tools, measuring various data points such as creativity, learning,
            leisure, friendship, and self-rated health, providing a
            comprehensive overview of the resident's current level of happiness.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/quality-of-life-page/capture-resident-wellness.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/quality-of-life-page/personalized-friend-matching.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Optimize Resident Care With Strategic Interventions
          </h2>
          <p class="card-text img-info-body">
            Leveraging intelligent Al, our platform focuses on residents with
            lower scores and generates personalized recommendations to enhance
            their Quality of Life.
            <br />
            <br />
            Automated interventions, including actionable insights
            notifications, activity calendar recommendations, friend-matching.
            and more enable staff members to proactively provide effective
            solutions for residents to improve their well-being.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
